import { IProductCardILayoutTypes, IProductCardILayoutVersions } from '@thryveai/theme-interfaces';
import {
  ILayoutInterface,
  layoutObjects,
} from '@thryveai/theme-interfaces/dist/product-card-template/template.interfaces';

export function resolveTemplate(
  location: IProductCardILayoutTypes,
  layout: IProductCardILayoutVersions
): { template: ILayoutInterface; version: IProductCardILayoutVersions } {
  const layoutVariants = layoutObjects[location];
  if (layoutVariants?.[layout]) {
    return { template: layoutVariants[layout], version: layout };
  }
  return { template: layoutVariants.default, version: 'default' };
}
